import * as yup from 'yup';
import { NotificationOverlay } from '@web/components';
import { schema as notificationOverlayItemSchema } from './notification_overlay_item';

export const component = NotificationOverlay;

export const schema = yup
  .object({
    alignment: yup.string(),
    notifications: yup.array(notificationOverlayItemSchema),
  })
  .transform(value => ({
    alignment: value.alignment || undefined,
    notifications: value.notifications || [],
  }));
